export default "__VITE_ASSET__09521663__"